module.exports = __webpack_public_path__ + "img/zh2.95f0242b.png";